import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ques-analysis',
  templateUrl: './ques-analysis.component.html',
  styleUrls: ['./ques-analysis.component.scss']
})
export class QuesAnalysisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
